const URL_API =
  window.location.host.indexOf('localhost') < 0
    ? `${window.location.protocol}//${window.location.host}`
    : 'http://192.168.22.89:84'; // for debugging

export { URL_API };
